import e from "lodash/merge";
import o from "../globals/colors.js";
import r from "../variants/DistechDark.js";
import a from "./BaseDark.js";
const i = e(r, {
  // #region Springboard properties
  ...a,
  // Override or add additional theme properties here
  // Override Fusion colors until Figma tokens provides Distech dark theme.
  color: {
    ...r.color,
    background: {
      ...r.color.background,
      input: a.secondaryBackground
    },
    border: {
      ...r.color.border,
      surface: o.darkBlue200
    }
  },
  primaryBorder: o.darkBlue200
});
export {
  i as default
};
